import React from 'react';
import { FC } from 'react';

export const CheckboxSelected: FC<{}> = () => (
    <svg width='24px' height='24px' viewBox='0 0 24 24' transform='scale(0.75)'>
        <path className='tick' d='M6,6 v8 h16' strokeWidth='2' stroke='#FFFFFF' fill='none' transform='rotate(-45, 12, 12)'></path>
    </svg>
);
